// App.tsx
import React from 'react';
import Grid from './Grid';
import { Civs } from './Civs';
import TimerButton from './TimerButton';

const App: React.FC = () => {
  const getRandomCivs = (civs: string[], count: number) => {
    const shuffledCivs = civs.sort(() => 0.5 - Math.random());
    return shuffledCivs.slice(0, count);
  };

  const randomCivs = getRandomCivs(Civs.map(c => c.name), 8); // Get 8 random civs from the Civs array

  const rowCivilizations = randomCivs.slice(0, 4); // Get the first 4 civs from the random civs array
  const colCivilizations = randomCivs.slice(4); // Get the last 4 civs from the random civs array

  return (
    <div className="App">
      <div>
        <h1>Dash Game</h1>
        <h2>Gather a team, pick a cell, give a clue that links the two civs, tap for correct guess, tap twice for incorrect. <strong>How many can you get in 5 minutes?</strong></h2>
      </div>

      <Grid rowCivilizations={rowCivilizations} colCivilizations={colCivilizations} />
      <TimerButton />
      <div className='footer'>
        <a target='_blank' href='https://twitter.com/search?q=nac5&src=recent_search_click&f=live'>I built this while watching the #nac5 final, it's almost certainly buggy. But GLHF anyway. 14!</a>
      </div>
    </div>
  );
}

export default App;